// extracted by mini-css-extract-plugin
module.exports = {"Contact":"Contact_Contact__1KMxs","MapContainer":"Contact_MapContainer__9Bfqs","Map":"Contact_Map__3_L3C"};